import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_select2",
  "use": "icon-control_select2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_select2\"><g transform=\"translate(2 2)\" stroke=\"currentColor\" fill=\"transparent\"><rect x=\".5\" y=\".5\" width=\"11\" height=\"11\" rx=\"1\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.828 5.414L6 8.243 3.172 5.414\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol